export default __webpack_public_path__ + "static/12-f0dfedec36b6eeb46d0fa53081514a6f.jpg";